import { EmailTemplateProps } from '@helpers/Models';

/**
 * `EmailTemplateModal` is a reusable modal component for displaying rich HTML content,
 * typically used for viewing email templates in a preview format.
 *
 * @component
 * @param {EmailTemplateProps} props - Component props
 * @param {string} props.htmlContent - The HTML content to be rendered inside the modal.
 * @param {() => void} props.onClose - Callback function to close the modal.
 *
 * @returns {JSX.Element} A styled modal displaying the provided HTML content with a close button.
 */
export const EmailTemplateModal: React.FC<EmailTemplateProps> = ({
  htmlContent,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full relative p-6">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-2 right-2 text-xl"
        >
          X
        </button>
        <div
          className="text-sm text-gray-800 overflow-auto max-h-[70vh]"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    </div>
  );
};
